<div class="block-full-width" [ngClass]="{ vl: regionId === '128' }">
    <p class="bold">{{ 'BANKCARD_SEARCH_TITLE' | translate }}</p>

    <iframe
        id="ecomm2"
        #iframe
        *ngIf="!(ticketsLoading$ | async) && displayIframe && !(ticketsError$ | async)"
        [src]="tpsEndpoint | safeResourceUrl"
        [attr.aria-label]="'PURCHASED_TICKETS_FORM' | translate"
        [attr.name]="'PURCHASED_TICKETS_FORM' | translate"
        scrolling="no"></iframe>

    <ng-container *ngIf="!differentRegionTickets">
        <ridango-ui-basic-loading-spinner
            *ngIf="!(tickets$ | async) && (ticketsLoading$ | async)"
            [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"></ridango-ui-basic-loading-spinner>

        <div
            class="notification-display__button"
            *ngIf="
                ((tickets$ | async) && !(ticketsLoading$ | async)) ||
                (!(ticketsLoading$ | async) && (ticketsError$ | async))
            ">
            <button class="btn btn--primary btn--square margin-bottom-30" (click)="newSearch()">
                {{ 'BANKCARD_HISTORY_NEW_SEARCH' | translate }}
            </button>
        </div>

        <ng-container *ngIf="(tickets$ | async) && !(ticketsLoading$ | async)">
            <div *ngIf="!(tickets$ | async).length">
                {{ 'BANKCARD_PAGE_NO_TICKETS_DESC' | translate }}
            </div>

            <rwidget-bankcard-tickets-table
                *ngIf="(tickets$ | async) && (tickets$ | async).length > 0"
                [tickets]="tickets$ | async"
                [loading]="ticketsLoading$ | async"
                [regionId]="regionId"></rwidget-bankcard-tickets-table>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="differentRegionTickets">
        <ridango-ui-basic-loading-spinner
            *ngIf="
                !(tickets$ | async) &&
                (ticketsLoading$ | async) &&
                !(hslTickets$ | async) &&
                (hslTicketsLoading$ | async)
            "
            [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"></ridango-ui-basic-loading-spinner>

        <div
            class="notification-display__button"
            *ngIf="
                ((tickets$ | async) || (hslTickets$ | async) || (ticketsError$ | async)) &&
                (!(ticketsLoading$ | async) || !(hslTicketsLoading$ | async))
            ">
            <button class="btn btn--primary btn--square margin-bottom-30" (click)="newSearch()">
                {{ 'BANKCARD_HISTORY_NEW_SEARCH' | translate }}
            </button>
        </div>

        <mat-tab-group
            *ngIf="
                ((tickets$ | async) && !(ticketsLoading$ | async)) ||
                ((hslTickets$ | async) && !(hslTicketsLoading$ | async))
            ">
            <mat-tab [aria-label]="'HSL_LABEL_HELSINKI' | translate" label="{{ 'HSL_LABEL_HELSINKI' | translate }}">
                <ng-template matTabContent>
                    <ridango-ui-basic-loading-spinner
                        *ngIf="hslTicketsLoading$ | async"
                        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"></ridango-ui-basic-loading-spinner>

                    <div
                        class="padding-30"
                        *ngIf="
                            (!(hslTickets$ | async) || !(hslTickets$ | async).length) && !(hslTicketsLoading$ | async)
                        ">
                        {{ 'BANKCARD_PAGE_NO_TICKETS_DESC' | translate }}
                    </div>

                    <rwidget-bankcard-tickets-table
                        *ngIf="(hslTickets$ | async) && (hslTickets$ | async).length > 0"
                        [tickets]="hslTickets$ | async"
                        [loading]="hslTicketsLoading$ | async"></rwidget-bankcard-tickets-table>
                </ng-template>
            </mat-tab>

            <mat-tab
                [aria-label]="'HSL_LABEL_TALLINN_TARTU' | translate"
                label="{{ 'HSL_LABEL_TALLINN_TARTU' | translate }}">
                <ng-template matTabContent>
                    <ridango-ui-basic-loading-spinner
                        *ngIf="ticketsLoading$ | async"
                        [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"></ridango-ui-basic-loading-spinner>

                    <div
                        class="padding-30"
                        *ngIf="(!(tickets$ | async) || !(tickets$ | async).length) && !(ticketsLoading$ | async)">
                        {{ 'BANKCARD_PAGE_NO_TICKETS_DESC' | translate }}
                    </div>

                    <rwidget-bankcard-tickets-table
                        *ngIf="(tickets$ | async) && (tickets$ | async).length > 0"
                        [tickets]="tickets$ | async"
                        [loading]="ticketsLoading$ | async"></rwidget-bankcard-tickets-table>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </ng-container>
</div>
